import React from 'react';

const Lost = () => (
  <div className="panel panel-default lost">
    <p>This is a lost territory! Don't know how you got here :(</p>
  </div>
);

export default Lost;
